<template>
  <div class="page" :class="bodyHide==1?'border-box overflow':''" v-wechat-title="$route.meta.title">

    <div class="video-box" :class="playIOS == 1? 'playIOS' : ''"  >
      <video id="videoPlay" :src="bagInfo.videourl" :poster="bagInfo.headimg" preload="auto"
             webkit-playsinline="true" playsinline="true" x5-playsinline="true" x-webkit-airplay="allow"
             @play="videoPlay" @pause="videoPause" :class="isplay == 0 && platIOS == 0? 'paused' : ''"
             controls controlsList='nodownload noremote footbar'></video>
      <img class="view-video-btn" src="../../assets/icon_play_btn03.png" alt=""v-if="skover==1" @click="playVideo()">
      <p class="view-video-mask" v-if="skover==1"><span>试看结束，购买继续观看</span></p>
      <p class="view-video-tip" v-if="skover!=1&&isplay==0&&res.isbuy == false">{{bagInfo.trytime}}秒试看</p>
    </div>

    <div class="video-bar" style="display: none;">
      <span class="video-bar-img" @click="playVideo()">
        <img src="../../assets/video_02.png" v-if="isplay == 0" />
        <img src="../../assets/video_01.png" v-else />
      </span>
      <span class="video-bar-time video-bar-left">{{currTime|initTime}}</span>
      <p class="video-bar-slide"><span :style="{width:currSlider}"></span></p>
      <span class="video-bar-time video-bar-right">{{totalTime|initTime}}</span>
    </div>

    <div class="video-info border-box">
      <div class="video-info-title">
        <h3>{{bagInfo.name}} <span>￥{{bagInfo.price}}</span></h3>
        <p>
          <span>1000+次播放 &nbsp;&nbsp;|</span>
          <span v-if="bagInfo.buynum>0">&nbsp;&nbsp; {{bagInfo.buynum|initNumber}}人购买 &nbsp;&nbsp;|</span>
          <span>&nbsp;&nbsp; 视频时长{{bagInfo.totaltime}}</span>
        </p>
      </div>
      <div class="video-info-des">
        <p class="tit">简介</p>
        <div>{{bagInfo.info || '暂无简介'}}</div>
      </div>
    </div>

    <!--新增评论头部-->
    <div class="comments-list-top clearfix border-box" id="comments-list-top">
      <span class="fl">游客点评</span>
      <span @click="commentsShow" class="fr commentBtn">我要点评
        <img src="../../assets/icon-write.png" />
      </span>
    </div>

    <!--新增底部评论详情列表-->
    <div class="comments-list border-box account-list-sr">
      <div v-for="(item,index) in commentList" :key="index" class="comments-list-data box border-box">
        <p class="block head-img-box">
          <img class="img" v-lazy="item.rzimg?item.rzimg:item.headimg"/>
        </p>

        <div class="flex comments-list-info  border-box">
          <div class="comments-person-box box ">
            <div class="block comments-person">
              <p class="comments-person-name hide">{{item.name}}</p>
              <p class="star-level">
                <template v-for="(star,index) in [2,4,6,8,10]">
                  <img v-if="item.score>=star" src="../../assets/icon_com.png"/>
                  <img v-else  src="../../assets/start_nor.png" />
                </template>
                <span class="icon-reward-small" v-if="item.isds">赏</span>
              </p>
            </div>
            <p @click="uploadZan(index)" class="praise">
              <span>{{item.totalZan}}</span>
              <img v-if="item.iszan==1" src="../../assets/zan_already.png" />
              <img v-else src="../../assets/zan_already_no.png" />
            </p>
          </div>

          <div class="comments-detail border-box">
            <p class="comments-detail-top">{{item.content}}</p>
          </div>

          <div v-if="item.allimg" class="comments-img box border-box">
            <img v-for="(ite,index) in item.allimg"  @click="seeImg(index,item.allimg)" v-lazy="ite" />
          </div>

          <div class="block comments-person-time">
            {{item.addtime}}
            <!--<span @click="replay" class="comments-person-hf fr" v-if="res.isguide && item.replys.length<1"><img src="../../assets/icon_play_btn11.png" />回复</span>-->
            <span v-if="item.state==2" class="shz-text fr none">审核中</span>
          </div>

          <div v-if="item.replys" class="comments-detail-replay border-box">
            <div v-for="(item,index) in item.replys" :key="index" class="comments-replay-text">
              <span>{{item.bagname}}</span> 回复
              <span>{{item.name}}</span> ：{{item.content}}
            </div>
          </div>
        </div>
      </div>
      <router-link :to="{path:'/comment',query: {id:this.$route.query.id,isbuy:res.isbuy,isguide:res.isguide, TimeStamp: TimeStamp, appKey: appKeyA}}">
        <div class="bottom-box border-box">
          <p class="select-more">查看共{{bagInfo.comments}}条评论</p>
        </div>
      </router-link>

      <p class="load-tip" ref="loadtip" style="display: none;"></p>
    </div>

    <!--底部购买按钮-->
    <div class="bottom-btn-box border-box" v-if="res.isbuy==false">
      <button class="bottom-btn" style="border-radius:0!important;" @click="buyVideo()">立即购买</button>
    </div>

    <!--试听结束弹窗新版-->
    <AlertListenEnd  :bag="bag" :couponid="couponid" :extral="extral" @close="closeEnd" v-if="Object.keys(bag).length>0"></AlertListenEnd>

    <!--新版本评论弹窗8-21-->
    <AlertComment :bagInfo="bagInfo" :class="{'curr':commentShow==1,'none':commentShow!=1}"  @child-Comment="closeComment"></AlertComment>

    <!--提醒用户购买弹窗弹窗-->
    <AlertPayTip @close="closePayTip" :comeForm="1"  v-if="buyTip==1"></AlertPayTip>

    <!--IOS或Android系统购买成功后提示收藏弹窗-->
    <div class="system-alert" v-show="paySuccess==1">
      <img class="system-img" v-show="platIOS==1" src="../../assets/pay-ios.png" alt="">
      <img class="system-img" v-show="platIOS==0" src="../../assets/pay-android.png" alt="">
      <div class="system-btn" @click="paySuccess=0">知道了</div>
    </div>
  </div>

</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import {getVideoPlayView,getBagComment, getZan} from "@/service/getData";
  import {wxImgPreview, wxShareme,listenEndOrder, creatOrder, pushOrder } from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import AlertListenEnd from '../../components/AlertListenEnd'
  import AlertComment from '../../components/AlertComment'
  import AlertPayTip from '../../components/AlertPayTip'

  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  var fromPath,fullPath;
  export default {
    data(){
      return{
        id: '', //专辑id
        spotid: '', //景点id
        shopid: '', //景区id
        userInfo: {}, //用户信息

        res:'',//接口所有数据
        bagInfo:'',//专辑详情

        commentList:[],//评论数据
        commentListLen:0,//评论条数
        commentShow:0,//评论弹窗
        rewardShow:0,//打赏弹窗
        bodyHide:0,//页面是否滚动
        memuText:'菜单',//菜单按钮文字
        menuCurr:0,//菜单按钮动画
        feedbackShow:0,//意见反馈弹窗
        isDs: false, //是否打赏过

        Video:  '', //视频dom
        videoTimer: null, //语音播放计时器
        isplay: 0, //当前语音是否播放
        currSlider: 0, //当前进度条
        currTime: 0, //当前播放音频的实时时间
        totalTime: 0, //总时间
        skover: 0, //是否是看结束
        buyTip: 0, //购买提醒弹窗

        bag:{}, //当前试听的专辑
        extral:{}, //存放下单需要的值
        couponid: '', //优惠券id
        action: '', //订单推送消息
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey:'',
        form: '', //来自哪个页面
        platIOS:'',//判断手机系统
        playIOS:'',//判断是否是IOS播放
        paySuccess:this.$route.query.paySuccess,//是否支付成功后跳转到该页面
      }
    },
    computed: {

    },
    created() {
      this.global.set_glabalClear()

      this.id = this.$route.query.id;
      this.shopid = this.$route.query.shopid;
      this.form = this.$route.query.form;

      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }

      this.action = this.$route.query.action;
      if(this.action == "cancel"){
        let self = this;
        this.$confirm({
          title: '提示',
          content: '取消推送授权，退出后将找不到页面入口，需要重新授权吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            pushOrder('dist/index.html#/video-play1?id='+self.id + '&TimeStamp='+ self.TimeStamp + '&appKey='+ (self.appKey));
          }
        }).catch(function(res){
          if(res == 'success') {
            pushOrder('dist/index.html#/video-play1?id='+self.id + '&TimeStamp='+ self.TimeStamp + '&appKey='+ (self.appKey));
          }
        })
      }
      this.$loading.show('数据加载中');
      this.initData();
      this.initComment();
      this.platSystem();
    },
    beforeDestroy(){

    },
    beforeRouteEnter (to, from, next) {
      if(from.path.indexOf('video-play1') > -1){
        fromPath = 'video-play1';
        fullPath = to.fullPath;
      }
      next();
    },
    mounted(){
      if(fromPath == 'video-play1'){
        this.$router.replace({
          path: fullPath
        });
      }
      if(this.form == 'pay'){
        window.addEventListener("popstate", function(e) {
          window.history.go(-6);
        }, false);
        pushHistory();
        function pushHistory() {
          var state = {
            title: "title",
            url: ""
          };
          window.history.pushState(state, "title", "");
        }
      }
    },
    methods: {

      async initData(){
        this.userInfo = getStore("userInfo");
        let res = await getVideoPlayView({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          bagid: this.id
        });
        if (res.errcode === "00000") {
          this.$loading.hide();
          this.res = res.data;
          this.bagInfo = res.data.bag;

          document.documentElement.scrollTop = document.body.scrollTop = 0;

          let title = this.userInfo.name + '@你：';
          let desc = '我正在“金牌解说”观看'+ this.bagInfo.shopname +'的历史故事，一起来观看吧';
          let img = this.bagInfo.tvideourl ? this.bagInfo.tvideourl : this.bagInfo.headimg;
          let link = '/video-play1?id='+ this.id +'&shopid='+ this.shopid +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          wxShareme(title,desc,img,link);

          this.$route.meta.title = this.bagInfo.shopname;

        }
      },

      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      //获取评论数据
      async initComment(){
        let res = await getBagComment({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: 1,
          rows: 5,
          bagid: this.id
        });

        if (res.errcode === "00000"){
          if (res.data.root.length > 0) {
            this.commentList = res.data.root;
            this.commentListLen = res.data.root.length;
          }
        }
      },

      //评论弹窗隐藏
      closeComment :function(msg){
        this.commentShow = msg.commentShow;
        if(msg.success){
          this.initComment();
        }
      },

      //评论弹窗显示隐藏
      commentsShow(){
        if(!this.res.isbuy){
          this.$toast('请先购买')
        }else{
          this.commentShow = 1
        }
      },

      //用户评论点赞
      async uploadZan(index){
        let res = await getZan({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          commentid: this.commentList[index].id
        });
        if(res.errcode == "00000"){
          this.commentList[index].totalZan++;
          this.commentList[index].iszan = 1;
          this.$toast("点赞成功",{ location: ''})
        }else{
          this.$toast(res.errmsg,{ location: ''})
        }
      },

      //关闭试听弹窗，购买成功修改音频状态
      closeEnd(msg){
        this.bag = msg.bag;
        if(msg.isbuy){
          this.res.isbuy = true;
        }
      },

      //图片预览
      seeImg(ind,imgs){
        wxImgPreview(imgs[ind],imgs);
      },

      //点击购买，调用下订单公用方法
      buyVideo(){
        let self = this;

        setStore("source", {"source": "video"});
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+self.bagInfo.id+'&cid='+self.couponid+'&shopid='+self.bagInfo.shopid+'&bagtype=1'+'&appKey='+(self.appKey)}`
        });

//        creatOrder(this,this.bagInfo,"",function(data){
//          if(data){
////            self.res.isbuy = true;
//            pushOrder('dist/index.htmlJH/video-play1?id='+self.bagInfo.id+'ANDspotid='+self.bagInfo.spotid+'ANDshopid='+self.bagInfo.shopid + 'ANDTimeStamp='+ self.TimeStamp + 'ANDappKey='+ self.appKey);
//          }
//        })
      },

      //关闭购买提醒弹窗
      closePayTip(msg){
        this.buyTip = msg;
      },


      //新增视频播放

      //判断手机 系统
      platSystem(){
        let ua = navigator.userAgent.toLowerCase();
        let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
        let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          this.platIOS = 1
        } else if (/(Android)/i.test(navigator.userAgent)) {
          this.platIOS = 0
        }
      },

      playVideo(){
        this.Video = document.getElementById("videoPlay");

        if(this.Video.paused){
          if(this.res.isbuy == false && this.skover == 1){  //没购买且试看结束
            this.buyTip = 1;
          }else {
            if(this.res.isbuy == true){  //已经购买
              var currVoice = getStore("currVoice",1) || "";
              if(currVoice && currVoice.currTime > 0 && currVoice.currId == this.id){
                this.Video.currentTime = currVoice.currTime;
                setStore("currVoice", {"currTime":0,"currId":"","spotid":""},1);
              }
            }
            this.Video.play();
            this.isplay = 1;
            this.timeUpdate();
            if(this.Video.readyState != 4){
              this.$loading.show('视频加载中');
            }
          }

        }else {
          this.Video.pause();
          this.isplay = 0;
          if(this.videoTimer != null){
            clearInterval(this.videoTimer);
          }
        }

      },
      videoPlay(){
        this.Video = document.getElementById("videoPlay");

        if(this.res.isbuy == false && this.skover == 1){  //没购买且试看结束
          this.buyTip = 1;
          this.Video.pause();
        }else {
          if(this.res.isbuy == true){  //已经购买
            var currVoice = getStore("currVoice",1) || "";
            if(currVoice && currVoice.currTime > 0 && currVoice.currId == this.id){
              this.Video.currentTime = currVoice.currTime;
              setStore("currVoice", {"currTime":0,"currId":"","spotid":""},1);
            }
          }
          this.Video.play();
          this.isplay = 1;
          this.timeUpdate();
          if(this.Video.readyState != 4){
            this.$loading.show('视频加载中');
          }
        }
        //IOS系统播放视频
//        if(this.platIOS == 1){
//          this.playIOS = 1;
//        }
      },
      videoPause(){
        this.Video = document.getElementById("videoPlay");
        this.isplay = 0;
        if(this.videoTimer != null){
          clearInterval(this.videoTimer);
        }

        //IOS系统播放视频
//        if(this.platIOS == 1 && this.res.isbuy == false){
//          this.playIOS = 0;
//        }

      },

      timeUpdate(){
        let self = this;
        if(self.videoTimer != null){
          clearInterval(self.videoTimer);
        }

        self.videoTimer = setInterval(function () {
          if(self.Video.currentTime > 0){
            self.totalTime = self.Video.duration;
            self.$loading.hide();
          }

          if(self.Video.currentTime != undefined && !isNaN(self.Video.currentTime)){
            self.currTime = self.Video.currentTime;
            self.currSlider = (self.Video.currentTime * 100 / self.totalTime) + "%";
          }

          if(self.res.isbuy == false){
            setStore("currVoice", {"currTime":self.Video.currentTime,"currId":self.id},1);
            console.log(self.Video.currentTime,self.bagInfo.trytime)
            if(self.Video.currentTime >= self.bagInfo.trytime){
              self.Video.pause();
              self.isplay = 0;
              self.buyTip = 1;
              self.skover = 1;
              clearInterval(self.videoTimer);

//              //IOS系统播放视频
//              if(self.platIOS == 1){
//                self.playIOS = 0;
//              }
            }
          }
        }, 1000);

        self.Video.onended = function() {  //音频播放结束
          self.isplay = 0;
          clearInterval(self.videoTimer);
        };
      },


    },
    watch:  {
      bag(newVal,oldVal){
        if(Object.keys(newVal).length){
          listenEndOrder(this,this.index1,this.bagInfo,true);
        }
      }
    },
    components: {
      AlertListenEnd,
      AlertComment,
      wxConfirm,
      AlertPayTip
    },
    //格式化数据
    filters: {
      //格式化数字
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      }
    },
    destroyed () {//新增离开该页面需要移除监听评论距离顶部距离属性
    },
  }

</script>

<style scoped>
  @import '../../style/alert.css';

  .page{width:100%;padding-bottom:1.12rem;background-color: #fff; }
  .video-box{position:relative;width: 100%;margin:0;background: #000; }
  .video-box video{width: 100%; object-fit: cover; }
  .view-video-btn{position:absolute;top:50%;left:50%;width: .9rem;height: .9rem;margin: -.45rem 0 0 -.45rem;z-index: 9;}
  .view-video-mask{position:absolute;top:0;left:0;width: 100%;height: 100%; z-index: 8;  background-color: #000; }
  .view-video-mask span{position:absolute;top:50%;left:0;width: 100%;height: .9rem;margin-top:.45rem; line-height: .9rem; font-size: .26rem; color: #fff; text-align: center; background-color: #000; }
  .view-video-tip{position:absolute;top:.22rem;right:.15rem;padding:0 .22rem;height: .45rem;line-height: .45rem;font-size: .24rem; color: #fff; z-index: 7; border-radius: .45rem;  background-color: rgba(0,0,0,.7); }

  .video-bar{ position: relative; padding: .23rem .8rem .22rem 1.46rem; height: .37rem; background-color: #f6f8fa; }
  .video-bar-img{ position: absolute; left: .3rem; top: .23rem; width: .3rem; height: .37rem; }
  .video-bar-img img{ width: auto; height: 100%; }
  .video-bar-time{ position: absolute; top: .23rem; height: .37rem; line-height: .37rem; color: #666; font-size: .2rem; }
  .video-bar-left{ left: .85rem; }
  .video-bar-right{ right: .18rem; }
  .video-bar-slide{ position: relative; width: 100%; height: .13rem; margin-top: .12rem; background-color: #e3e4e8; border-radius: .13rem; overflow: hidden; }
  .video-bar-slide span{ position: absolute; left: 0; top: 0; height: .13rem; background-color: #fcba5a; border-radius: .13rem; }

  .bottom-btn-box{position:fixed;left:0;bottom:0;width:100%;height:1.12rem;background: #fff;z-index:1;box-shadow:0 0 .05rem #ddd;}
  .bottom-btn{ left: 1.5rem; width:100%;height:1.12rem;line-height:1.12rem;color:#fff;background: #faaf39;z-index:1;text-align:center;font-size:.36rem;letter-spacing:.04rem;}

  .video-info{width: 100%; padding: .35rem .28rem 0; }
  .video-info-title{ padding-bottom: .2rem; border-bottom: 1px solid #ddd; }
  .video-info-title h3{ position: relative; padding: 0 1rem .2rem 0; font: bold .36rem/.4rem "Microsoft YaHei"; color: #0d0d0d; }
  .video-info-title h3 span{position: absolute; right: 0; top: 0; font: bold .3rem/.4rem "Microsoft YaHei"; color: #e66100; }
  .video-info-title p{ font: .2rem/.3rem "Microsoft YaHei"; color: #525883; }

  .video-info-des .tit{ padding: .3rem 0 .25rem; font-size: .28rem; font-weight: 600; color: #000; }
  .video-info-des div{ padding-bottom: .4rem; font: .26rem/.4rem "Microsoft YaHei"; color: #666; border-bottom: 1px solid #ddd; }

  /*新增底部评论详情列表*/
  .comments-list{width:100%;padding:.36rem 0  .16rem .24rem; margin-bottom: 0; }
  .comments-list-top{width:100%;height:.88rem;padding:0 .22rem;border-bottom:1px solid #F0F0F0;}
  .comments-list-top .fl{font:bold .32rem/.88rem "Microsoft YaHei";color:#333;}
  .comments-list-top .fr{font:.28rem/.88rem "Microsoft YaHei";color:#666;}
  .comments-list-top .fr img{float:right;width:.29rem;height:.32rem;margin:.28rem 0 0 .16rem;}
  .comments-list .bottom-box{position:relative;width:100%;height:.88rem;background:#fff;}
  .select-more{height:.88rem;line-height:.88rem;font-size:.30rem;color:#faaf39;text-align:center;background: none;}
  .icon-reward-small{float:left;height:.26rem;line-height:.26rem;margin-top:-.03rem;margin-left:.05rem;padding:0 .10rem;font-size:.16rem;color:#fff;background:#f5681b;border-radius:.05rem;}
  .list-img .type-lable{position:absolute;left:-50%;top:-.08rem;width:1.80rem;height:.40rem;line-height:.40rem;margin-left:.35rem;color: #fff;font-size: .21rem;background: #ffbd08;transform: rotate(-45deg);text-align: center;box-shadow:0 .05rem .10rem #cec6b7;}
  .shz-text{margin-right:.24rem;color:#ff5400;font-size:.24rem;}


  .paused{  height: 4.5rem; }
  .video-box.playIOS{ position: fixed;top: 0;left: 0;width: 100vw;height: 100vh;z-index: 9;}
  .video-box.playIOS #videoPlay{position: absolute;top: 50%; left: 50%; width: auto; height: 84vw;background: #000;object-fit: cover;-webkit-transform:translate(-50%,-50%) rotate(90deg);transform: translate(-50%,-50%) rotate(90deg);-webkit-transition: all ease .3s;transition: all ease .3s;}

  /*购买成功后提示收藏弹窗*/
  .system-alert{position: fixed;z-index: 11;top:0;left: 0;width: 100vw;height: 100vh;background: rgba(0,0,0,.9);}
  .system-img{display: block;width: 70%;height: auto;margin: .8rem auto 0;}
  .system-btn{display: block;width: 2.32rem;height: .72rem;margin:.82rem auto;border: 1px dashed #fff;font: .28rem/.72rem "Microsoft YaHei";color: #fff;border-radius: .03rem;}
</style>



// WEBPACK FOOTER //
// src/page/video-play1/video-play1.vue